import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@nextiva/next-ui-components';
import { Footer, Action, CancelBtn, SaveBtn } from './Footer.styles';

const DrawerFooter = ({
  cancelOnClick,
  cancelText,
  saveOnClick,
  saveText,
  saveEnabled,
  cancelEnabled,
  hideSave,
  hideCancel,
}) => {
  return (
    <Footer>
      <Action>
        <Grid container spacing={1}>
          {!hideCancel && (
            <Grid item>
              <CancelBtn
                id="locationDrawerCancelBtn"
                color="secondary"
                variant="contained"
                onClick={cancelOnClick}
                disabled={!cancelEnabled}
                data-testid={`PlatformAdminUI-TeamVoiceSettings-Drawer-${cancelText}-Button`}
              >
                {cancelText}
              </CancelBtn>
            </Grid>
          )}
          {!hideSave && (
            <Grid item>
              <SaveBtn
                id="locationDrawerSaveBtn"
                color="primary"
                variant="contained"
                onClick={saveOnClick}
                disabled={!saveEnabled}
                data-testid={`PlatformAdminUI-TeamVoiceSettings-Drawer-${saveText}-Button`}
              >
                {saveText}
              </SaveBtn>
            </Grid>
          )}
        </Grid>
      </Action>
    </Footer>
  );
};

DrawerFooter.propTypes = {
  cancelEnabled: PropTypes.bool,
  cancelOnClick: PropTypes.func,
  cancelText: PropTypes.string,
  hideCancel: PropTypes.bool,
  hideSave: PropTypes.bool,
  saveEnabled: PropTypes.bool,
  saveOnClick: PropTypes.func,
  saveText: PropTypes.string,
};

DrawerFooter.defaultProps = {
  cancelOnClick: () => {},
  cancelText: 'Cancel',
  saveOnClick: () => {},
  saveText: 'Save',
  hideSave: false,
  saveEnabled: true,
  hideCancel: false,
  cancelEnabled: true,
};

export default DrawerFooter;
